"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("player-core/utils");
exports.default = {
    createUUID: utils_1.createUUID
};
//# sourceMappingURL=__exports.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/__exports.js
// module id = 909
// module chunks = 0